(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9190],{

/***/ 74373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SD": function() { return /* binding */ TagCloseButton; },
/* harmony export */   "Sn": function() { return /* binding */ TagLabel; },
/* harmony export */   "Vp": function() { return /* binding */ Tag; }
/* harmony export */ });
/* unused harmony exports TagLeftIcon, TagRightIcon, useTagStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52494);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28387);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15818);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54520);
// ../../../react-shim.js


// src/tag.tsx



var [TagStylesProvider, useTagStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `TagStylesContext`,
  errorMessage: `useTagStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tag />" `
});
var Tag = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Tag", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const containerStyles = {
    display: "inline-flex",
    verticalAlign: "top",
    alignItems: "center",
    maxWidth: "100%",
    ...styles.container
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TagStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    ...ownProps,
    __css: containerStyles
  }));
});
Tag.displayName = "Tag";
var TagLabel = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = useTagStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    noOfLines: 1,
    ...props,
    __css: styles.label
  });
});
TagLabel.displayName = "TagLabel";
var TagLeftIcon = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
  ref,
  verticalAlign: "top",
  marginEnd: "0.5rem",
  ...props
}));
TagLeftIcon.displayName = "TagLeftIcon";
var TagRightIcon = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
  ref,
  verticalAlign: "top",
  marginStart: "0.5rem",
  ...props
}));
TagRightIcon.displayName = "TagRightIcon";
var TagCloseIcon = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
  verticalAlign: "inherit",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
}));
TagCloseIcon.displayName = "TagCloseIcon";
var TagCloseButton = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const { isDisabled, children, ...rest } = props;
  const styles = useTagStyles();
  const btnStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "0",
    ...styles.closeButton
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.button */ .m$.button, {
    ref,
    "aria-label": "close",
    ...rest,
    type: "button",
    disabled: isDisabled,
    __css: btnStyles
  }, children || /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TagCloseIcon, null));
});
TagCloseButton.displayName = "TagCloseButton";



/***/ }),

/***/ 61742:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cart",
      function () {
        return __webpack_require__(2055);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page_header_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/index.esm.js
var dist_index_esm = __webpack_require__(73238);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/breadcrumb/AppBreadcrumb.tsx





function AppBreadcrumb(param) {
    let { breadcrumb  } = param;
    // use router
    const { pathname  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Breadcrumb */.aG, {
            separator: ">",
            color: "gray.600",
            className: "app-breadcrumb",
            children: breadcrumb.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* BreadcrumbItem */.gN, {
                    isCurrentPage: pathname === item.href,
                    children: item.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.href,
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* BreadcrumbLink */.At, {
                            children: item.label
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        noOfLines: 1,
                        children: item.label
                    })
                }, index))
        })
    });
}
/* harmony default export */ var breadcrumb_AppBreadcrumb = (AppBreadcrumb);

;// CONCATENATED MODULE: ./components/page-header/PageHeader.tsx




function PageHeader(param) {
    let { title , breadcrumb , backLink , containerMaxWidth ="850px"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                borderBottom: "1px solid",
                borderColor: "primary.400",
                pt: 8,
                pb: 4,
                bgGradient: "linear(to-t, white 55%, #ffd5b1 100%)",
                display: {
                    base: "none",
                    lg: "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    maxWidth: containerMaxWidth,
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            color: "gray.600",
                            fontWeight: "300",
                            fontSize: "lg",
                            children: title
                        }),
                        breadcrumb && breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            fontSize: "lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_AppBreadcrumb, {
                                breadcrumb: breadcrumb
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                py: 2,
                display: {
                    base: "block",
                    lg: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            color: "gray.600",
                            fontWeight: "300",
                            fontSize: "md",
                            children: title
                        }),
                        breadcrumb && breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_AppBreadcrumb, {
                            breadcrumb: breadcrumb
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var page_header_PageHeader = (PageHeader);


/***/ }),

/***/ 61053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47741);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





function PageTitleMobile(param) {
    let { children , backLink  } = param;
    // use router
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
        bg: "#F36621",
        height: "32px",
        display: {
            lg: "none"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
            h: "100%",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .Ug, {
                color: "white",
                h: "100%",
                children: [
                    backLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                        variant: "unstyled",
                        minW: "auto",
                        minHeight: "auto",
                        onClick: ()=>{
                            router.push(backLink, backLink, {
                                locale: router.locale
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/image-icon/arrow-prev-white.png",
                            width: 9,
                            height: 12,
                            alt: "next"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                        fontSize: "17px",
                        fontWeight: "400",
                        color: "white",
                        children: children
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PageTitleMobile);


/***/ }),

/***/ 2055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ cart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/checkbox/dist/index.esm.js + 1 modules
var checkbox_dist_index_esm = __webpack_require__(9135);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(20979);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var axios = __webpack_require__(70594);
;// CONCATENATED MODULE: ./node_modules/axios/index.js


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const {
  Axios,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken,
  VERSION,
  all: axios_all,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders,
  formToJSON
} = axios/* default */.Z;



// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(83022);
// EXTERNAL MODULE: ./hooks/useCatchError.ts
var useCatchError = __webpack_require__(65633);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./respository/cart.repository.ts
var cart_repository = __webpack_require__(61015);
;// CONCATENATED MODULE: ./components/carts/CartCoupon.tsx









function CartCoupon() {
    // use i18n
    const { t  } = (0,useTranslation/* useTranslation */.$)([
        "cart"
    ]);
    // use catch error hook
    const catchError = (0,useCatchError/* default */.Z)();
    // use react-hook-form
    const { handleSubmit , register , formState: { errors  }  } = (0,react_hook_form_dist_index_esm/* useForm */.cI)();
    const { cartMutate  } = (0,useCart/* default */.Z)();
    // use state to store coupon error message
    const [couponErrorMessage, setCouponErrorMessage] = (0,react.useState)("");
    // use state to store coupon submit loading
    const [couponSubmitLoading, setCouponSubmitLoading] = (0,react.useState)(false);
    const handleApplyCoupon = async (values)=>{
        try {
            // reset coupon error message
            setCouponErrorMessage("");
            // set coupon submit loading
            setCouponSubmitLoading(true);
            const data = await cart_repository/* CartRepository.applyCoupon */.e.applyCoupon(values.code);
            ;
            cartMutate();
        } catch (error) {
            ;
            catchError(error);
            if (error instanceof AxiosError) {
                if (error.response && error.response.data) {
                    if (error.response.data.error === "COUPON_NOT_FOUND") {
                        setCouponErrorMessage(t("ไม่พบคูปองหรือคูปองหมดอายุแล้ว", {
                            ns: "cart"
                        }));
                    }
                }
            }
        } finally{
            // set coupon submit loading
            setCouponSubmitLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit(handleApplyCoupon),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
            alignItems: "flex-start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                    flex: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input_dist_index_esm/* Input */.II, {
                            type: "text",
                            placeholder: t("cart.coupon.placeholder", {
                            }),
                            ...register("code", {
                                required: t("form.message.required", {
                                    ns: "common"
                                })
                            }),
                            _placeholder: {
                                color: "gray.200"
                            },
                            bg: "white",
                            border: "0"
                        }),
                        couponErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                            color: "red.600",
                            fontSize: "sm",
                            mt: 2,
                            children: couponErrorMessage
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                    flex: "0 0 auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                        bg: "gray.800",
                        type: "submit",
                        isLoading: couponSubmitLoading,
                        children: t("cart.coupon.action.apply", {
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var carts_CartCoupon = (CartCoupon);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckOutlined.js
var CheckOutlined = __webpack_require__(88284);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseOutlined.js
var CloseOutlined = __webpack_require__(28508);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__(35610);
// EXTERNAL MODULE: ./components/inputs/InputNumber.tsx
var InputNumber = __webpack_require__(55947);
// EXTERNAL MODULE: ./components/utils/UtilPriceFormatter.tsx
var UtilPriceFormatter = __webpack_require__(74046);
// EXTERNAL MODULE: ./interfaces/product.interface.ts
var product_interface = __webpack_require__(75779);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
;// CONCATENATED MODULE: ./hooks/useCartItem.ts



function useCartItem(param) {
    let { item  } = param;
    // init is remove cart item
    const [isRemoveCartItem, setIsRemoveCartItem] = (0,react.useState)(false);
    // get attributes name from item
    const attributesNames = (0,react.useMemo)(()=>{
        if (item.product && item.attributeOptions && item.attributeOptions.length > 0 && item.product.attributes) {
            // get attribute by attributesOptions.productAttributeId
            const attributes = item.product.attributes.filter((attribute)=>{
                const _attribute = item.attributeOptions.some((attributeOption)=>attributeOption.productAttributeId === attribute.id);
                return _attribute;
            });
            ;
            // assign attributeOption to attribute
            const attributesWithOptions = attributes.map((attribute)=>{
                const attributeOptions = item.attributeOptions.filter((attributeOption)=>attributeOption.productAttributeId === attribute.id);
                return {
                    ...attribute,
                    attributeOptions
                };
            });
            ;
            // get attribute name
            const attributeNames = attributesWithOptions.map((attribute)=>{
                if ((router_default()).locale === "en") {
                    return "".concat(attribute.name_en, " : ").concat(attribute.attributeOptions[0].name_en);
                } else {
                    if (attribute.name_th) {
                        return "".concat(attribute.name_th, " : ").concat(attribute.attributeOptions[0].name_th);
                    } else {
                        return "".concat(attribute.name_en, " : ").concat(attribute.attributeOptions[0].name_en);
                    }
                }
            });
            return attributeNames;
        }
        return [];
    }, [
        item
    ]);
    // get attributes name from item short
    const attributesNamesShort = (0,react.useMemo)(()=>{
        if (item.product && item.attributeOptions && item.attributeOptions.length > 0 && item.product.attributes) {
            // get attribute by attributesOptions.productAttributeId
            const attributes = item.product.attributes.filter((attribute)=>{
                const _attribute = item.attributeOptions.some((attributeOption)=>attributeOption.productAttributeId === attribute.id);
                return _attribute;
            });
            ;
            // assign attributeOption to attribute
            const attributesWithOptions = attributes.map((attribute)=>{
                const attributeOptions = item.attributeOptions.filter((attributeOption)=>attributeOption.productAttributeId === attribute.id);
                return {
                    ...attribute,
                    attributeOptions
                };
            });
            ;
            // get attribute name
            const attributeNames = attributesWithOptions.map((attribute)=>{
                if ((router_default()).locale === "en") {
                    return "".concat(attribute.attributeOptions[0].name_en);
                } else {
                    if (attribute.name_th) {
                        return "".concat(attribute.attributeOptions[0].name_th);
                    } else {
                        return "".concat(attribute.attributeOptions[0].name_en);
                    }
                }
            });
            ;
            return attributeNames;
        }
        return [];
    }, [
        item
    ]);
    // get variation from item
    const variation = (0,react.useMemo)(()=>{
        if (item.product && item.attributeOptions && item.attributeOptions.length && item.product.variations) {
            const variation = item.product.variations.find((variation)=>{
                var _variation_attributeOptions;
                const _variation = (_variation_attributeOptions = variation.attributeOptions) === null || _variation_attributeOptions === void 0 ? void 0 : _variation_attributeOptions.every((attributeOption)=>{
                    const _attributeOption = item.attributeOptions.some((itemAttributeOption)=>itemAttributeOption.id === attributeOption.id);
                    return _attributeOption;
                });
                return _variation;
            });
            return variation;
        }
        return null;
    }, [
        item
    ]);
    const featuresImage = (0,react.useMemo)(()=>{
        if (variation) {
            if (variation.gallery && variation.gallery.length > 0) {
                var _variation_gallery_;
                return "".concat("https://storage.lamptan.co.th", "/").concat((_variation_gallery_ = variation.gallery[0]) === null || _variation_gallery_ === void 0 ? void 0 : _variation_gallery_.name);
            }
        } else {
            if (item.product) {
                if (item.product.featuredImage) {
                    return "".concat("https://storage.lamptan.co.th", "/").concat(item.product.featuredImage.name);
                }
            }
        }
        return "/image-icon/empty-image.png";
    }, [
        item.product
    ]);
    // get sku from product or variation
    const sku = (0,react.useMemo)(()=>{
        if (variation) {
            return variation.sku;
        } else {
            var _item_product;
            return (_item_product = item.product) === null || _item_product === void 0 ? void 0 : _item_product.sku;
        }
    }, [
        item,
        variation
    ]);
    const isAvailableForPurchase = (0,react.useMemo)(()=>{
        if (item.product.status !== product_interface/* ProductStatusEnum.PUBLISHED */.X.PUBLISHED) {
            return false;
        }
        if (variation) {
            return variation.stockQuantity && variation.stockQuantity > 0 && variation.visibility && variation.claimedPrice && variation.claimedPrice > 0 && variation.weight && variation.weight > 0;
        } else {
            return item.product.stockQuantity && item.product.stockQuantity > 0 && item.product.weight && item.product.weight > 0;
        }
    }, [
        item,
        variation
    ]);
    return {
        isRemoveCartItem,
        setIsRemoveCartItem,
        attributesNames,
        attributesNamesShort,
        featuresImage,
        variation,
        sku,
        isAvailableForPurchase
    };
}

// EXTERNAL MODULE: ./hooks/useProductItem.ts
var useProductItem = __webpack_require__(13043);
// EXTERNAL MODULE: ./hooks/useUser.ts + 1 modules
var useUser = __webpack_require__(42409);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/carts/CartItem.tsx















function CartItem(param) {
    let { item  } = param;
    // use user
    const { user  } = (0,useUser/* default */.Z)();
    // use media query
    const [isTablet] = (0,index_esm/* useMediaQuery */.ac)("(min-width: 768px)");
    const [isDesktop] = (0,index_esm/* useMediaQuery */.ac)("(min-width: 992px)");
    // use catch error
    const catchError = (0,useCatchError/* default */.Z)();
    // use cart
    const { cartItemDelete , cartItemQuantityUpdate , cartItemSelect  } = (0,useCart/* default */.Z)();
    // use cart item
    const { sku , isRemoveCartItem , isAvailableForPurchase , setIsRemoveCartItem  } = useCartItem({
        item
    });
    // use product item
    const { name: productName , featuredImage , variationNameWithAttributes  } = (0,useProductItem/* default */.Z)({
        product: item.product,
        variation: item.variation
    });
    // init quantity
    const [quantity, setQuantity] = (0,react.useState)(item.quantity);
    // init has buy 1 get 1
    const [hasBuy1Get1, setHasBuy1Get1] = (0,react.useState)(false);
    // init cart remove loading
    const [isCartRemoveLoading, setIsCartRemoveLoading] = (0,react.useState)(false);
    // init cart select loading state
    const [isCartSelectLoading, setIsCartSelectLoading] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setQuantity(item.quantity);
        setHasBuy1Get1(item.buy1Get1Id && item.buy1Get1Id > 0 ? true : false);
    }, [
        item
    ]);
    const cartItemQuantityUpdateApi = async (key, quantity)=>{
        try {
            const itemUpdated = await cart_repository/* CartRepository.updateQuantity */.e.updateQuantity({
                key,
                quantity
            });
            ;
            if (itemUpdated.buy1Get1Id && itemUpdated.buy1Get1Id > 0) {
                setHasBuy1Get1(true);
            }
        } catch (error) {
            catchError(error);
        }
    };
    const debouncedUpdateQuantity = (0,react.useRef)((0,lodash.debounce)(cartItemQuantityUpdateApi, 1000)).current;
    const handleCartRemoveItem = async ()=>{
        try {
            setIsRemoveCartItem(true);
            setIsCartRemoveLoading(true);
            if (user && user.isAuthenticated) {
                await cart_repository/* CartRepository.removeItem */.e.removeItem(item.key);
            }
            cartItemDelete(item.key);
            setIsRemoveCartItem(false);
        } catch (error) {
            catchError(error);
        } finally{
            setIsCartRemoveLoading(false);
        }
    };
    const handleCartItemSelect = async ()=>{
        try {
            if (user && user.isAuthenticated) {
                setIsCartSelectLoading(true);
                await cart_repository/* CartRepository.itemSelectUpdate */.e.itemSelectUpdate(item.key, !item.selected);
            }
            cartItemSelect(item.key, !item.selected);
        } catch (error) {
            catchError(error);
        } finally{
            setIsCartSelectLoading(false);
        }
    };
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
        bg: "#EADED0",
        px: {
            base: 2,
            md: 4
        },
        py: {
            base: 4,
            md: 4
        },
        opacity: !isAvailableForPurchase ? 0.7 : 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                spacing: {
                    base: 2,
                    md: 4
                },
                alignItems: "initial",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        flex: "0 0 auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                            boxSize: {
                                base: "25px",
                                lg: "30px"
                            },
                            minW: "auto",
                            padding: "0",
                            bg: "white",
                            variant: "unstyled",
                            border: "1px solid white",
                            justifyContent: "center",
                            alignItems: "center",
                            _hover: {
                                borderColor: "primary.500"
                            },
                            onClick: handleCartItemSelect,
                            isDisabled: isCartSelectLoading || !isAvailableForPurchase,
                            children: isCartSelectLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                boxSize: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                                    size: "md"
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: item.selected && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                    textAlign: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/image-icon/check-active.png",
                                        width: 20,
                                        height: 20,
                                        alt: "checked",
                                        style: {
                                            margin: "auto",
                                            width: isDesktop ? "20px" : isTablet ? "20px" : "16px"
                                        }
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        flex: "0 0 auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                            boxSize: {
                                base: "60px",
                                md: "80px",
                                lg: "80px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* AspectRatio */.oM, {
                                ratio: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "\n                /products/".concat(item.product.permalink, "\n              "),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: featuredImage,
                                        alt: "featuredImage",
                                        width: 80,
                                        height: 80
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                        flex: "1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                fontSize: {
                                    base: "sm",
                                    md: "md",
                                    lg: "2xl"
                                },
                                fontWeight: 400,
                                textTransform: "uppercase",
                                mb: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "\n                /products/".concat(item.product.permalink, "\n              "),
                                    children: productName
                                })
                            }),
                            variationNameWithAttributes.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* HStack */.Ug, {
                                mb: 1,
                                children: variationNameWithAttributes.map((attributeName, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                        fontSize: {
                                            base: "xs",
                                            md: "sm"
                                        },
                                        whiteSpace: "nowrap",
                                        children: attributeName
                                    }, index))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* HStack */.Ug, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                    fontSize: {
                                        base: "xs",
                                        md: "sm"
                                    },
                                    whiteSpace: "nowrap",
                                    children: [
                                        "Seller SKU : ",
                                        sku
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                        flex: {
                            base: "1 1 100%",
                            md: "0 0 70px"
                        },
                        textAlign: "right",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        children: [
                            isRemoveCartItem ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                justifyContent: "flex-end",
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        variant: "unstyled",
                                        p: 0,
                                        minW: "0",
                                        height: "auto",
                                        color: "primary.500",
                                        onClick: handleCartRemoveItem,
                                        isLoading: isCartRemoveLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckOutlined/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                        variant: "unstyled",
                                        p: 0,
                                        minW: "0",
                                        height: "auto",
                                        color: "gray.500",
                                        onClick: ()=>{
                                            setIsRemoveCartItem(false);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {})
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                variant: "unstyled",
                                p: 0,
                                minW: "0",
                                height: "auto",
                                onClick: ()=>{
                                    setIsRemoveCartItem(true);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/image-icon/trash.png",
                                    alt: "trash",
                                    width: 13,
                                    height: 18,
                                    quality: "100"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                flex: "0 0 auto",
                                children: [
                                    item.salePrice > 0 && item.salePrice !== item.regularPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                        fontSize: "sm",
                                        color: "gray.500",
                                        as: "s",
                                        whiteSpace: "nowrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                            price: item.regularPrice
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                        fontWeight: "500",
                                        fontSize: "17px",
                                        whiteSpace: "nowrap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                            price: item.salePrice ? item.salePrice : item.regularPrice
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                textAlign: "right",
                borderTop: "1px solid #666",
                mt: 3,
                pt: 2,
                justifyContent: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                        justifyContent: "flex-end",
                        children: [
                            isAvailableForPurchase ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                flex: "0 0 70px",
                                alignSelf: "flex-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* HStack */.Ug, {
                                    flex: "0 0 70px",
                                    bg: "white",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNumber/* default */.Z, {
                                        size: "xs",
                                        step: 1,
                                        min: 1,
                                        max: item.maxQuantity,
                                        value: quantity ? quantity : 1,
                                        isDisabled: isAvailableForPurchase ? false : true,
                                        onChange: (valueAsString, valueAsNumber)=>{
                                            if (!isAvailableForPurchase) {
                                                return;
                                            }
                                            let _quantity = valueAsNumber;
                                            setQuantity(_quantity);
                                            cartItemQuantityUpdate(item.key, _quantity);
                                        },
                                        onBlur: ()=>{
                                            if (user && user.isAuthenticated) {
                                                debouncedUpdateQuantity(item.key, quantity);
                                            }
                                        }
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                flex: "0 0 auto",
                                alignSelf: "flex-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                    color: "red.500",
                                    children: "ไม่พร้อมให้บริการ"
                                })
                            }),
                            item.subTotal && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                textAlign: "right",
                                minW: "100px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                    fontSize: "2xl",
                                    color: "primary.500",
                                    fontWeight: 400,
                                    lineHeight: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                        price: item.subTotal
                                    })
                                })
                            })
                        ]
                    }),
                    item.buyXGetX ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        mt: 3,
                        mb: -2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                            fontSize: "sm",
                            color: "primary.500",
                            fontWeight: 500,
                            children: [
                                "\uD83C\uDF81 แถมฟรี: ",
                                item.buyXGetX.getX * item.quantity,
                                " ชิ้น"
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
}
/* harmony default export */ var carts_CartItem = (CartItem);

// EXTERNAL MODULE: ./components/page-header/PageHeader.tsx + 1 modules
var PageHeader = __webpack_require__(64070);
// EXTERNAL MODULE: ./components/page-header/PageTitleMobile.tsx
var PageTitleMobile = __webpack_require__(61053);
// EXTERNAL MODULE: ./hooks/useShop.ts
var useShop = __webpack_require__(28801);
// EXTERNAL MODULE: ./layouts/RootLayout.tsx + 10 modules
var RootLayout = __webpack_require__(89806);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tag/dist/index.esm.js
var tag_dist_index_esm = __webpack_require__(74373);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js
var notification = __webpack_require__(26855);
;// CONCATENATED MODULE: ./components/carts/CartCouponItem.tsx









function CartCouponItem(param) {
    let { coupon  } = param;
    const { user  } = (0,useUser/* default */.Z)();
    const { t  } = (0,useTranslation/* useTranslation */.$)([
        "cart"
    ]);
    // use cart
    const { cart , cartMutate  } = (0,useCart/* default */.Z)();
    // use catch error hook
    const catchError = (0,useCatchError/* default */.Z)();
    // loading
    const [couponRemoveLoading, setCouponRemoveLoading] = react.useState(false);
    const handleRemoveCoupon = async ()=>{
        try {
            setCouponRemoveLoading(true);
            if (user && user.isAuthenticated) {
                const cartUpdated = await cart_repository/* CartRepository.removeCoupon */.e.removeCoupon(coupon.id);
                // show notification
                notification/* default.success */.Z.success({
                    message: t("cart.coupon.remove.success.message"),
                    description: t("cart.coupon.remove.success.description")
                });
                cartMutate({
                    ...cart,
                    ...cartUpdated
                });
            } else {
                alert("โปรดเข้าสู่ระบบก่อน");
            }
        } catch (error) {
            catchError(error);
        } finally{
            setCouponRemoveLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tag_dist_index_esm/* Tag */.Vp, {
        colorScheme: coupon.available ? "primary" : "gray",
        size: "md",
        variant: "solid",
        children: [
            coupon.code,
            couponRemoveLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_dist_index_esm/* Spinner */.$, {
                size: "xs",
                ml: 2
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* TagCloseButton */.SD, {
                onClick: handleRemoveCoupon
            })
        ]
    }, coupon.id);
}
/* harmony default export */ var carts_CartCouponItem = (CartCouponItem);

;// CONCATENATED MODULE: ./pages/cart.tsx



















const CartPage = (param)=>{
    let { cartProp  } = param;
    // use router
    const router = (0,next_router.useRouter)();
    // use catchError
    const catchError = (0,useCatchError/* default */.Z)();
    // use user
    const { user  } = (0,useUser/* default */.Z)();
    const [isDesktop] = (0,index_esm/* useMediaQuery */.ac)("(min-width: 992px)");
    // use translation
    const { t  } = (0,useTranslation/* useTranslation */.$)([
        "cart"
    ]);
    // get cart
    const { cart , cartIsAllSelected , cartIsInterMediateSelected , cartSelectedCount , cartSubTotal , cartTotal , cartShippingTotal , cartWeightTotal , cartItemSelectAll , cartSetShippingMethod , cartMutate  } = (0,useCart/* default */.Z)(cartProp);
    // get shipping methods from shop
    const { shippingMethodAvailable  } = (0,useShop/* default */.Z)();
    // use state to store coupon remove loading
    const [couponRemoveLoading, setCouponRemoveLoading] = (0,react.useState)(false);
    // get items
    const items = (cart === null || cart === void 0 ? void 0 : cart.items) || [];
    // handle cart submit
    const handleCartSubmit = (0,react.useCallback)(async ()=>{
        try {
            ;
            if (!cart) return;
            if (!(cart === null || cart === void 0 ? void 0 : cart.shippingMethodId)) {
                return;
            }
            if (user && user.isAuthenticated) {
                const cartUpdated = await cart_repository/* CartRepository.updateShippingMethod */.e.updateShippingMethod(cart === null || cart === void 0 ? void 0 : cart.shippingMethodId);
                await cart_repository/* CartRepository.validateBeforeCheckout */.e.validateBeforeCheckout();
                cartMutate(cartUpdated);
            }
            router.push("/checkout");
        } catch (error) {
            catchError(error);
        }
    }, [
        cart
    ]);
    (0,react.useEffect)(()=>{
        if (cartWeightTotal) {
            if (cartWeightTotal > 2000) {
                cartSetShippingMethod(1); // ems
            }
        }
    }, [
        cartWeightTotal
    ]);
    var _cart_discountTotal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: t("cart.title", {
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                        title: t("cart.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitleMobile/* default */.Z, {
                        children: t("cart.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Container */.W2, {
                        pt: {
                            base: 6,
                            lg: 10
                        },
                        pb: {
                            base: 0,
                            lg: 20
                        },
                        children: cart && items.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                    mb: 3,
                                    alignItems: "flex-end",
                                    display: {
                                        base: "none",
                                        lg: "flex"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                            fontSize: "2xl",
                                            fontWeight: 400,
                                            children: t("cart.title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                            children: [
                                                "(",
                                                t("cart.count", {
                                                    // TH: {{count}} รายการ
                                                    // EN: {{count}} items
                                                    count: items.length
                                                }),
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Grid */.rj, {
                                    templateColumns: {
                                        base: "repeat(1, 1fr)",
                                        md: "repeat(2, 1fr)",
                                        lg: "1fr 280px"
                                    },
                                    columnGap: 7,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                                borderBottom: {
                                                    base: "10px solid #F2F2F2",
                                                    lg: "none"
                                                },
                                                mx: {
                                                    base: -4,
                                                    lg: 0
                                                },
                                                pb: 2,
                                                px: {
                                                    base: 4,
                                                    lg: 0
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                        borderTop: "1px solid #e2e2e2",
                                                        borderBottom: "1px solid #e2e2e2",
                                                        mb: 4,
                                                        py: 2,
                                                        px: 4,
                                                        display: {
                                                            base: "none",
                                                            lg: "flex"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                boxSize: "30px",
                                                                minW: "auto",
                                                                padding: "0",
                                                                bg: "white",
                                                                variant: "unstyled",
                                                                border: "1px solid #e2e2e2",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                _hover: {
                                                                    borderColor: "primary.500"
                                                                },
                                                                onClick: ()=>cartItemSelectAll(cartIsAllSelected ? false : cartIsInterMediateSelected ? false : true),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                                    textAlign: "center",
                                                                    children: cartIsAllSelected || cartIsInterMediateSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: cartIsAllSelected ? "/image-icon/check-active.png" : "/image-icon/minus-active.png",
                                                                        width: 20,
                                                                        height: 20,
                                                                        alt: "checked",
                                                                        style: {
                                                                            margin: "auto",
                                                                            width: isDesktop ? 20 : 16
                                                                        }
                                                                    }) : null
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                children: t("cart.selectAll", {
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    cart && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Stack */.Kq, {
                                                            spacing: 4,
                                                            mb: 4,
                                                            children: items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(carts_CartItem, {
                                                                    item: item
                                                                }, index))
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* GridItem */.P4, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                                    px: {
                                                        base: 0,
                                                        lg: 4
                                                    },
                                                    py: {
                                                        base: 4,
                                                        lg: 4
                                                    },
                                                    bg: {
                                                        base: "white",
                                                        lg: "#EADED0"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                                            borderBottom: "1px solid #666",
                                                            mb: 2.5,
                                                            pb: 3,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(carts_CartCoupon, {}),
                                                                cart && cart.coupons && cart.coupons.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* HStack */.Ug, {
                                                                    mt: 2,
                                                                    children: cart.coupons.map((coupon, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(carts_CartCouponItem, {
                                                                            coupon: coupon
                                                                        }, index))
                                                                })
                                                            ]
                                                        }),
                                                        shippingMethodAvailable && shippingMethodAvailable.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                                            borderBottom: "1px solid #666",
                                                            mb: 2.5,
                                                            pb: 3,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                                                    fontSize: "md",
                                                                    mb: 2,
                                                                    fontWeight: 400,
                                                                    children: t("cart.shippingMethod.title", {
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* HStack */.Ug, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* CheckboxGroup */.cO, {
                                                                        value: [
                                                                            cart.shippingMethodId
                                                                        ],
                                                                        children: shippingMethodAvailable.map((shippingMethod, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(checkbox_dist_index_esm/* Checkbox */.XZ, {
                                                                                flex: 1,
                                                                                size: "lg",
                                                                                colorScheme: "primary",
                                                                                fontSize: "md",
                                                                                className: "checkbox-white-bg",
                                                                                value: shippingMethod.id,
                                                                                disabled: cartWeightTotal > 2000 && 3 === shippingMethod.id,
                                                                                onChange: (e)=>{
                                                                                    cartSetShippingMethod(+e.target.value);
                                                                                },
                                                                                isChecked: cart.shippingMethodId === shippingMethod.id,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                                    as: "span",
                                                                                    fontSize: "md",
                                                                                    children: router.locale === "th" ? shippingMethod.name_th : shippingMethod.name_en
                                                                                })
                                                                            }, index))
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
                                                            borderBottom: "1px solid #666",
                                                            mb: 2,
                                                            pb: 3,
                                                            spacing: 1,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                                    justifyContent: "space-between",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                            children: t("cart.summary.subTotal", {
                                                                                // TH: {{count}} รายการ
                                                                                // EN: {{count}} items
                                                                                count: cartSelectedCount
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                                                                price: cartSubTotal
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                cart.discountTotal > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                                    justifyContent: "space-between",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                                            flex: 1,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                                children: t("cart.summary.discount.label", {
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                                            flex: "0 0 auto",
                                                                            textAlign: "right",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                                                                    price: (_cart_discountTotal = cart.discountTotal) !== null && _cart_discountTotal !== void 0 ? _cart_discountTotal : 0
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                                    justifyContent: "space-between",
                                                                    alignItems: "flex-start",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                            children: t("cart.summary.shippingTotal", {
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                                            textAlign: "right",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                                                                    price: cartShippingTotal !== null && cartShippingTotal !== void 0 ? cartShippingTotal : 0
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                                justifyContent: "space-between",
                                                                fontWeight: 400,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                        children: t("cart.summary.total", {
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                        fontSize: "lg",
                                                                        color: "primary.500",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                                                            price: cartTotal
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                    mb: 6,
                                                    display: {
                                                        md: "none"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                        fontSize: "sm",
                                                        textAlign: "center",
                                                        children: "**ในกรณีค่าขนส่งมีการเปลี่ยนแปลง ทางบริษัทขออนุญาตติดต่อกลับลูกค้า**"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                    spacing: 0,
                                                    alignItems: "initial",
                                                    mx: {
                                                        base: -4,
                                                        lg: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                            flex: "0 0 auto",
                                                            display: {
                                                                base: "block",
                                                                lg: "none"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                                                bg: "gray.800",
                                                                height: "100%",
                                                                px: 6,
                                                                minW: "100px",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                    color: "white",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                                                        price: cartTotal !== null && cartTotal !== void 0 ? cartTotal : 0
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                            flex: 1,
                                                            fontSize: "lg",
                                                            height: {
                                                                base: "50px",
                                                                lg: "40px"
                                                            },
                                                            disabled: cartTotal === 0,
                                                            onClick: handleCartSubmit,
                                                            children: t("cart.checkout", {
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                    mt: 4,
                                                    display: {
                                                        base: "none",
                                                        lg: "block"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                                        fontSize: "sm",
                                                        textAlign: "center",
                                                        children: [
                                                            "**ในกรณีค่าขนส่งมีการเปลี่ยนแปลง",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "ทางบริษัทขออนุญาตติดต่อกลับลูกค้า**"
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Center */.M5, {
                            pt: {
                                base: 16,
                                lg: 0
                            },
                            minH: {
                                base: "auto",
                                lg: "300px"
                            },
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                    mb: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/image-icon/shopping-large.png",
                                        width: 70,
                                        height: 70,
                                        alt: "empty-cart",
                                        style: {
                                            margin: "auto"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                    textAlign: "center",
                                    fontSize: "2xl",
                                    mb: 8,
                                    children: t("cart.empty", {
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    height: "55px",
                                    size: "lg",
                                    fontSize: "xl",
                                    minW: {
                                        base: "100%",
                                        lg: "350px"
                                    },
                                    onClick: ()=>router.push("/product-categories/lighting"),
                                    children: t("cart.continueShoppingButton", {
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
CartPage.getLayout = (page)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(RootLayout/* default */.Z, {
        children: page
    });
var __N_SSP = true;
/* harmony default export */ var cart = (CartPage);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8641,5675,1664,3863,4645,5359,1559,2077,2883,7001,9806,9774,2888,179], function() { return __webpack_exec__(61742); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);